"use client";

import {FaSearch} from "react-icons/fa";
import {usePathname, useRouter, useSearchParams} from "next/navigation";
import {useState} from "react";

export default function SearchPro({himSelf, value}){
    const router = useRouter();

    const searchParam = useSearchParams();
    const [searchParams, setSearchParams] = useState({});
    const pathname = usePathname();
    const {replace} = useRouter();

    const handleSearch = async e => {
        e.preventDefault();
        const params = new URLSearchParams(searchParam);

        if(searchParams.search){
            params.set('search', searchParams.search)
        }else{
            params.delete('search')
        }

        if(himSelf){
            replace(`${pathname}?${params.toString()}`);
        }else{
            router.push(`/pros?${params.toString()}`);
        }

    }
    //TODO /pros?search=terms
    return (
        <div className={"bg-[#F0A20220] rounded-full"}>
            <form className={"p-2 relative"} onSubmit={handleSearch}>
                <input
                    type={"text"}
                    placeholder={"Que recherchez-vous ?"}
                    defaultValue={value}
                    className={"rounded-full border-none placeholder:italic placeholder:font-thin px-4 w-full "}
                    onChange={e => setSearchParams({...searchParams, search : e.target.value})}
                />
                <div className={"absolute right-0 top-0 mt-3 mx-4"}>
                    <button className={"bg-cwfBlue hover:bg-cwfOrange p-2 rounded-full"}>
                        <FaSearch className={"text-white"}/>
                    </button>
                </div>
            </form>
        </div>
    )
}